import { Component, ViewChild, Input, OnInit, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'lfwms-datepicker-grid',
  templateUrl: './datepicker-grid.component.html',
  styleUrls: ['./datepicker-grid.component.css']
})
export class GridDatepickerComponent implements OnInit {

  public currentDate: string;

  @Input() public inputDate: any;
  @Input() public isDropup: boolean = false;
  @Input() public offset: number = 0;

  @Output() public valueChanged: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('primeFocusInput') primeFocusInput: any;

  public ngOnInit() {
    if (this.inputDate && this.inputDate.cVal) {
      this.currentDate = this.inputDate.cVal;
    }
  }

  public setFocus() {
    this.primeFocusInput.inputfieldViewChild.nativeElement.focus();
  }

  public onFocus() {
    const intervalID = setInterval(() => {
      if (this.primeFocusInput.overlayViewChild) {
        if (!this.isDropup) {
          if (this.isDropup === false) {
            this.primeFocusInput.overlayViewChild.nativeElement.style.top = '19px';
          } else {
            this.primeFocusInput.overlayViewChild.nativeElement.style.left = 'unset';
            this.primeFocusInput.overlayViewChild.nativeElement.style.right = '10%';
            this.primeFocusInput.overlayViewChild.nativeElement.style.top = this.offset + 'px';
          }
        } else {
          this.primeFocusInput.overlayViewChild.nativeElement.style.bottom = '19px';
        }
        this.primeFocusInput.overlayViewChild.nativeElement.style.opacity = 1;
        this.primeFocusInput.overlayViewChild.nativeElement.style.visibility = 'visible';
        clearInterval(intervalID);
      }
    }, 1);
  }

  public onBlur() {
    // Pending Fix for overlay not getting hidden
  }

  public onSelect() {
    this.setFocus();
    this.inputDate.cVal = moment(this.currentDate).format('MM/DD/YYYY hh:mm A');
    this.valueChanged.emit();
  }

  public onInput() {
    const formattedDate: any = moment(this.currentDate).format('MM/DD/YYYY hh:mm A');
    this.inputDate.cVal = (formattedDate) ? formattedDate : '';
    this.valueChanged.emit();
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/datepicker-grid/datepicker-grid.component.ts